import { useState } from 'react';
import { useQuery } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is a client library, not a backend module
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: Convex generated dataModel lives outside src/
import type { TVoiceDashboardTimeRange } from '@/@types/voiceAgents';

const TIME_RANGE_MS: Record<TVoiceDashboardTimeRange, number> = {
  '24h': 86400000,
  '7d': 604800000,
  '30d': 2592000000,
};

export function useVoiceDashboardStats(orgId: Id<'organisations'> | undefined) {
  const [timeRange, setTimeRange] = useState<TVoiceDashboardTimeRange>('7d');

  const stats = useQuery(
    api.voiceCalls.dashboard.getDashboardStats,
    orgId !== undefined ? { orgId, timeRangeMs: TIME_RANGE_MS[timeRange] } : 'skip'
  );

  return {
    stats,
    timeRange,
    setTimeRange,
    isStatsLoading: stats === undefined,
  };
}
